document.addEventListener('DOMContentLoaded', () => {
  const guaranteeSection = document.querySelector('.dtc-guarantee--product-handle-the-hormone-harmony.dtc-hidden');
  const mainElement = document.querySelector('#r-1676882563490');
  const compareSection = document.querySelector('.dtc-compare');
  const compareLink = document.querySelector('.compare-a');

  if (guaranteeSection && mainElement) {
    mainElement.insertAdjacentElement('afterend', guaranteeSection);
    guaranteeSection.classList.remove('dtc-hidden');
  }

  if (guaranteeSection && compareSection) {
    guaranteeSection.insertAdjacentElement('afterend', compareSection);
  }

  if (compareLink) {
    compareLink.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});